/**
 * ODR-1703 追随リファクタ: 「コース開始処理」確認ポップアップ（飲み放題）の判定ロジック。
 *
 * ホーム（NotificationCategoryOption.vue）とカート（Cart.vue）で同じ処理が二重実装されており、
 * 片方だけ直して不整合になる事故が続いた（ODR-1701 C006 / ODR-1703）。
 * 共通コンポーネント CategoryOptionConfirm.vue から参照する純関数をここに集約する。
 *
 * 型は既存の共有モジュール（開始APIの型定義）を単一の真実として再利用する。
 */
import type {
  CategoryOptionRow,
  MatchedOrderRow,
} from "@/model/shop/table_session/startCategoryOption";

export type { CategoryOptionRow, MatchedOrderRow };

/** 開始APIへ送る matched_orders 1件の形 */
export interface MatchedOrderPayload {
  is_checked: boolean;
  order_id: string;
  option_price: number;
}

/** 残り時間(分)を delta だけ増減し、0〜600分にクランプして返す。非数値は0扱い。 */
export function clampLimitLength(current: number, delta: number): number {
  const n = Number(current);
  const base = Number.isFinite(n) ? n : 0;
  return Math.min(600, Math.max(0, base + delta));
}

/** 1件以上あって全て自動開始か。ボタン文言「飲み放題に含める」判定に使う。 */
export function isAllAutoStart(categoryOptions: CategoryOptionRow[]): boolean {
  return categoryOptions.length > 0 && categoryOptions.every((o) => !!o.is_auto_start);
}

/** 手動開始が1件でもあるか。残り時間の案内文（hall-0297）の表示判定に使う。 */
export function hasManualStart(categoryOptions: CategoryOptionRow[]): boolean {
  return categoryOptions.some((o) => !o.is_auto_start);
}

/** 巻き取り候補が全てチェック済みか（全チェックボックスの状態）。 */
export function isAllChecked(matchedOrders: MatchedOrderRow[]): boolean {
  return matchedOrders.every((m) => m.is_checked);
}

/** コース名を重複除去して結合（見出し表示用）。 */
export function uniqueOptionNames(categoryOptions: CategoryOptionRow[]): string {
  return Array.from(new Set(categoryOptions.map((o) => o.formatted_name))).join(", ");
}

/** 開始APIへ送る matched_orders ペイロードに整形する。 */
export function toMatchedOrdersPayload(matchedOrders: MatchedOrderRow[]): MatchedOrderPayload[] {
  return matchedOrders.map((o) => ({
    is_checked: o.is_checked,
    order_id: o.order_id,
    option_price: o.option_price,
  }));
}
